import { Prop, Schema, SchemaFactory } from '@nestjs/mongoose';
import { Document } from 'mongoose';
import { MultilingualTextSchema } from '@/common/schemas/multilingual-text.schema';

export type CountryDocument = Country & Document;

@Schema({ timestamps: true })
export class Country {
  @Prop({ type: MultilingualTextSchema, required: true })
  name: { en: string; ar: string };

  @Prop({ type: String, required: true, unique: true })
  code: string; // Country code (e.g., "US", "CA")

  @Prop({ type: Number, required: true, min: 0 })
  defaultShippingCost: number;

  @Prop({ type: Boolean, default: true })
  isActive: boolean;

  @Prop({ type: Date, default: Date.now })
  createdAt: Date;

  @Prop({ type: Date, default: Date.now })
  updatedAt: Date;
}

export const CountrySchema = SchemaFactory.createForClass(Country);